module.exports = __webpack_public_path__ + "img/六董会.84a2060a.jpg";